import React from 'react';
import { Modal, Spin, Empty, Timeline, Typography, Icon } from 'antd';
import moment from 'moment';
import cn from 'classnames';
import styles from './EntityHistory.module.scss';

const { Text } = Typography;
const { Item } = Timeline;

const EntityHistory = ({
  title,
  visible,
  onCancel,
  loading,
  items,
  modalProps,
}) => {
  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      {...modalProps}
    >
      <Spin spinning={loading || false}>
        {items?.length ? (
          <Timeline>
            {items.map((item, index) => (
              <Item
                key={index}
                color="#005ebe"
              >
                <div className={styles.timeLineItemWrap}>
                  <div
                    className={styles.row}
                    style={{ gap: '8px' }}
                  >
                    <Text className={styles.date}>
                      {moment(item.date).format('DD-MM-YYYY HH:mm')}
                    </Text>
                    <Text style={{ fontWeight: 500 }}>{item.operation}</Text>
                  </div>

                  {Boolean(item.newValue) && (
                    <div
                      className={cn(styles.row, styles.newValueRow)}
                      style={{ gap: '4px' }}
                    >
                      <Icon
                        type="caret-right"
                        className={styles.newValueIcon}
                      />
                      <Text>{item.newValue}</Text>
                    </div>
                  )}

                  <div
                    className={cn(styles.row, styles.creator)}
                    style={{ gap: '4px' }}
                  >
                    <Icon type="user" />
                    <Text className={styles.creatorName}>
                      {item.name || item.user}
                    </Text>
                  </div>
                </div>
              </Item>
            ))}
          </Timeline>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Нет изменений"
          />
        )}
      </Spin>
    </Modal>
  );
};

export default EntityHistory;
